import React, { lazy } from 'react';
import { AlertBar } from './components/AlertBar';
import { Hero } from './components/Hero';
import { SalesLetter } from './components/SalesLetter';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyMobileButton } from './components/StickyMobileButton';
export function App() {
  return <div className="min-h-screen bg-[#FFF0F5] font-body selection:bg-primary/30 w-full pb-20 md:pb-0" data-id="element-0">
      <AlertBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SalesLetter data-id="element-4" />
        <div className="px-4 pb-2 bg-transparent text-center" data-id="element-5">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-dark mb-3" data-id="element-6">
            🎉 ¡Nunca fue tan fácil decorar!
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/thL5HegVEgBxfU2rpUrtdR/IMG_8852.png" alt="4 pasos: Descargá, Imprimí, Decorá y +10000 Diseños Premium" className="w-full max-w-md mx-auto rounded-2xl" loading="lazy" width={448} height={280} data-id="element-7" />
        </div>
        <Testimonials data-id="element-8" />
        <div className="px-4 py-3 bg-transparent space-y-4 max-w-2xl mx-auto" data-id="element-9">
          {[{
          image: 'https://cdn.magicpatterns.com/uploads/62Y5eXvBfKnkkLswZPg8XX/IMG_8840.jpg',
          text: '"No puedo creer que lo hice yo sola"',
          name: '— Romina G.'
        }, {
          image: 'https://cdn.magicpatterns.com/uploads/jTRyaEmt3adBSBuxPFv985/IMG_8843.jpg',
          text: '"Quedó igual que en Pinterest"',
          name: '— Valentina M.'
        }, {
          image: 'https://cdn.magicpatterns.com/uploads/5NUQF9F6735HQhBcWBWTvM/IMG_8844.jpg',
          text: '"Empecé por mi hija y terminé con un negocio"',
          name: '— Florencia D.'
        }].map((item, i) => <div key={i} className="relative w-full rounded-2xl overflow-hidden shadow-md" style={{
          aspectRatio: '16/9'
        }} data-id="element-10">
              <img src={item.image} alt={item.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" width={672} height={378} data-id="element-11" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-id="element-12" />
              <div className="absolute bottom-0 left-0 right-0 p-5 text-white text-center" data-id="element-13">
                <p className="text-xs mb-1" data-id="element-14">⭐⭐⭐⭐⭐</p>
                <p className="text-base md:text-lg font-bold leading-snug mb-1" data-id="element-15">
                  {item.text}
                </p>
                <p className="text-sm font-medium opacity-90" data-id="element-16">{item.name}</p>
              </div>
            </div>)}
        </div>
        <FAQ data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
      <StickyMobileButton data-id="element-19" />
    </div>;
}